import React, { ReactNode } from "react";

import { Box } from "@mui/material";

import { MobileStepperHeader } from "./MobileStepperHeader";

export function MobilePageScaffold(props: {
  header: { activeStep: number; labels: string[] };
  children: ReactNode;
}) {
  return (
    <Box sx={{ pb: 10 /* espaço pro footer fixo */ }}>
      <MobileStepperHeader
        activeStep={props.header.activeStep}
        labels={props.header.labels}
      />
      <Box sx={{ mt: 2 }}>{props.children}</Box>
    </Box>
  );
}
